<template>
  <div class="classroom-list-filters">
    <Field 
      type="checkbox"
      name="has_upcoming_events"
      id="cb_has_upcoming_events"
      label="Show only courses with upcoming events"
      class="custom-control custom-checkbox mb-1"
      v-model="checked"
      :checkbox-value="1"
    />
  </div>
</template>

<script>
export default {
  props: {
    value: { type: Boolean, default: false }
  },
  data() {
    return {
      checked: false
    };
  },
  watch: {
    value(val) {
      this.checked = !!val;
    },
    checked(val) {
      this.$emit("input", !!val);
    }
  },
  created() {
    this.checked = !!this.value;
    this.$root.eventBus.$on('clear-all-filters', () => this.checked = false)
  }
}
</script>